import ParadexIcon from '#/assets/ParadexIcon';

import { useWalletView } from '#/features/wallet/wallet-context';
import * as walletFn from '#/features/wallet/functions';
import { useWalletModalActions } from '#/features/wallet/modal-context';

import { Address, BadgeContainer } from './atoms';

export default function WalletBadgeConnected() {
  const walletView = useWalletView();
  const modalActions = useWalletModalActions();

  return (
    <BadgeContainer
      onClick={modalActions.open}
      data-testid="paradex-wallet-connected-badge"
    >
      <ParadexIcon size={20} />
      <Address>{walletFn.maskAccount(walletView.starknetAddress)}</Address>
    </BadgeContainer>
  );
}
